export const translations = {
  clearAll: {
    default: "Clear all",
    en: "Clear all",
    da: "Ryd alle",
    nl: "Alles wissen",
    fi: "Tyhjennä kaikki",
    fr: "Tout effacer",
    de: "Alles löschen",
    no: "Tøm alle",
    sv: "Rensa alla",
  },
  seeAll: {
    default: "See all",
    en: "See all",
    da: "Se alle",
    nl: "Alles bekijken",
    fi: "Näytä kaikki",
    fr: "Voir tout",
    de: "Alle anzeigen",
    no: "Se alle",
    sv: "Visa alla",
  },
  colors: {
    default: "Colors",
    en: "Colors",
    da: "Farver",
    nl: "Kleuren",
    fi: "Värit",
    fr: "Couleurs",
    de: "Farben",
    no: "Farger",
    sv: "Färger",
  }, 
  sale: {
    default: "Sale",
    en: "Sale",
    da: "Udsalg",
    nl: "Uitverkoop",
    fi: "Ale",
    fr: "Soldes",
    de: "Sale",
    no: "Salg",
    sv: "Rea",
  },
  fitGuides: {
    default: "Fit guides",
    en: "Fit guides",
    da: "Pasformsguide",
    nl: "Pasvormgids",
    fi: "Sovitusopas",
    fr: "Guides des tailles",
    de: "Größenratgeber",
    no: "Størrelsesguide",
    sv: "Passformsguide",
  },
  shippingDelivery: {
    default: "Shipping & Delivery",
    en: "Shipping & Delivery",
    da: "Forsendelse og levering",
    nl: "Verzending en levering",
    fi: "Toimitus ja kuljetus",
    fr: "Expédition et livraison",
    de: "Versand & Lieferung",
    no: "Frakt og levering",
    sv: "Frakt och leverans",
  },
  returns: {
    default: "Returns",
    en: "Returns",
    da: "Returneringer",
    nl: "Retouren",
    fi: "Palautukset",
    fr: "Retours",
    de: "Rückgaben",
    no: "Retur",
    sv: "Returer",
  },
  tryOn: {
    default: "Try on",
    en: "Try on",
    da: "Prøv",
    nl: "Passen",
    fi: "Sovita",
    fr: "Essayer",
    de: "Anprobieren", 
    no: "Prøv",
    sv: "Prova",
  },
  products: {
    default: "Products",
    en: "Products",
    da: "Produkter",
    nl: "Producten",
    fi: "Tuotteet",
    fr: "Produits",
    de: "Produkte",
    no: "Produkter",
    sv: "Produkter",
  },
  noResultsFoundFor: {
    default: "No results found for",
    en: "No results found for",
    da: "Ingen resultater fundet for",
    nl: "Geen resultaten gevonden voor",
    fi: "Ei tuloksia haulle",
    fr: "Aucun résultat trouvé pour",
    de: "Keine Ergebnisse gefunden für",
    no: "Ingen resultater funnet for",
    sv: "Inga resultat hittades för",
  },
    searchResultsFor: {
      default: "Search results for",
      en: "Search results for",
      da: "Søgeresultater for",
      nl: "Zoekresultaten voor",
      fi: "Hakutulokset haulle",
      fr: "Résultats de recherche pour",
      de: "Suchergebnisse für",
      no: "Søkeresultater for",
      sv: "Sökresultat för",
    },
    apply: {
      default: "Apply",
      en: "Apply",
      da: "Anvend",
      nl: "Toepassen",
      fi: "Käytä",
      fr: "Appliquer",
      de: "Anwenden",
      no: "Bruk",
      sv: "Tillämpa filter",
    },
    noResults: {
      default: "We couldn't find any products matching this search. Please try again with different keywords.",
      en: "We couldn't find any products matching this search. Please try again with different keywords.",
      da: "Vi kunne ikke finde nogen produkter, der matcher denne søgning. Prøv igen med andre søgeord.",
      nl: "We konden geen producten vinden die overeenkomen met deze zoekopdracht. Probeer het opnieuw met andere zoekwoorden.",
      fi: "Emme löytäneet tuotteita, jotka vastaavat tätä hakua. Yritä uudelleen eri hakusanoilla.",
      fr: "Nous n'avons trouvé aucun produit correspondant à cette recherche. Veuillez réessayer avec d'autres mots-clés.",
      de: "Wir konnten keine Produkte finden, die zu dieser Suche passen. Bitte versuchen Sie es mit anderen Suchbegriffen erneut.",
      no: "Vi kunne ikke finne noen produkter som samsvarte med dette søket. Prøv igjen med andre søkeord.",
      sv: "Vi kunde inte hitta några produkter som matchade denna sökning. Försök igen med andra sökord.",
    },
    clearSearch: {
      default: "Clear search",
      en: "Clear search",
      da: "Ryd søgning",
      nl: "Zoekopdracht wissen",
      fi: "Tyhjennä haku",
      fr: "Effacer la recherche",
      de: "Suche löschen", 
      no: "Tøm søk",
      sv: "Rensa sökning",
    },
    searchHere: {
      default: "Search here",
      en: "Search here",
      da: "Søg her",
      nl: "Zoek hier",
      fi: "Hae tästä",
      fr: "Rechercher ici",
      de: "Hier suchen",
      no: "Søk her",
      sv: "Sök här",
    },
    suggestions: {
      default: "Suggestions",
      en: "Suggestions",
      da: "Forslag",
      nl: "Suggesties",
      fi: "Ehdotuksia",
      fr: "Suggestions",
      de: "Vorschläge",
      no: "Forslag",
      sv: "Förslag", 
    },
    popularSearches: {
      default: "Popular searches",
      en: "Popular searches",
      da: "Populære søgninger",
      nl: "Populaire zoekopdrachten",
      fi: "Suositut haut",
      fr: "Recherches populaires",
      de: "Beliebte Suchanfragen",
      no: "Populære søk",
      sv: "Populära sökningar",
    },
    popularSites: {
      default: "Popular sites",
      en: "Popular sites",
      da: "Populære sider",
      nl: "Populaire sites",
      fi: "Suositut sivustot",
      fr: "Sites populaires",
      de: "Beliebte Seiten",
      no: "Populære nettsteder",
      sv: "Populära sidor",
    },
    search: {
      default: "Search",
      en: "Search",
      da: "Søg",
      nl: "Zoeken",
      fi: "Haku",
      fr: "Recherche",
      de: "Suche",
      no: "Søk",
      sv: "Sök",
    },
    loading: {
      default: "Loading...",
      en: "Loading...",
      da: "Indlæser...",
      nl: "Laden...",
      fi: "Ladataan...",
      fr: "Chargement...",
      de: "Lädt...",
      no: "Laster...",
      sv: "Laddar...",
    },
    typeToSearch: {
      default: "Type to search...",
      en: "Type to search...",
      da: "Skriv for at søge...",
      nl: "Typ om te zoeken...",
      fi: "Kirjoita hakeaksesi...",
      fr: "Tapez pour rechercher...",
      de: "Tippen zum Suchen...",
      no: "Skriv for å søke...",
      sv: "Skriv för att söka...",
    },
    seeAllResults: {
      default: "See all results",
      en: "See all results",
      da: "Se alle resultater",
      nl: "Bekijk alle resultaten",
      fi: "Näytä kaikki tulokset",
      fr: "Voir tous les résultats",
      de: "Alle Ergebnisse anzeigen",
      no: "Se alle resultater",
      sv: "Visa alla resultat",
    },
    aboutUs: {
      default: "About Us",
      en: "About Us",
      da: "Om os",
      nl: "Over ons",
      fi: "Meistä",
      fr: "À propos de nous",
      de: "Über uns",
      no: "Om oss",
      sv: "Om Oss",
    },
    contact: {
      default: "Contact",
      en: "Contact",
      da: "Kontakt",
      nl: "Contact",
      fi: "Yhteystiedot",
      fr: "Contact",
      de: "Kontakt",
      no: "Kontakt",
      sv: "Kontakt",
    },
    faq: {
      default: "FAQ",
      en: "FAQ",
      da: "OSS",
      nl: "FAQ",
      fi: "UKK",
      fr: "FAQ",
      de: "FAQ",
      no: "OSS",
      sv: "FAQ",
    },
    cap: {
      default: "Cap",
      en: "Cap",
      da: "Kasket",
      nl: "Pet",
      fi: "Lippis",
      fr: "Casquette",
      de: "Mütze",
      no: "Caps",
      sv: "Keps",
    },
    overshirt: {
      default: "Overshirt",
      en: "Overshirt",
      da: "Overskjorte",
      nl: "Overshirt",
      fi: "Päällyspaita",
      fr: "Surchemise",
      de: "Overshirt",
      no: "Overskjorte",
      sv: "Overshirt",
    },
    vest: {
      default: "Vest",
      en: "Vest",
      da: "Vest",
      nl: "Bodywarmer",
      fi: "Liivi",
      fr: "Gilet",
      de: "Weste",
      no: "Vest",
      sv: "Väst",
    },
    suit: {
      default: "Suit",
      en: "Suit",
      da: "Jakkesæt",
      nl: "Kostuum",
      fi: "Puku",
      fr: "Costume",
      de: "Anzug",
      no: "Dress",
      sv: "Kostym",
    },
    golfBag: {
      default: "Golf bag",
      en: "Golf bag",
      da: "Golfbag",
      nl: "Golftas",
      fi: "Golfbägi",
      fr: "Sac de golf",
      de: "Golftasche",
      no: "Golfbag",
      sv: "Golfbag",
    },
  
  };
  